import { createSelector } from 'reselect';
import { resourcePath } from '@gameday/utils/resource-path';
import { getLanguagePath } from '@gameday/utils/languageHelpers';
const getArticleLinkType = (article) => {
    return article.isBlog ? 'recapCut4Link' : 'recapLink';
};

const getLanguage = (state) => state.config?.language ?? 'en';
const getDeviceInteraction = (state) => state.config?.deviceInteraction ?? {};
const getIsLoading = (state) => state.loading?.isLoading;

const getCoverage = (state) => {
    const language = getLanguage(state);

    const {
        morecoverage: {
            articles = []
        },
        gumbo: {
            gamePk = ''
        }
    } = state || {};

    const esToken = getLanguagePath(language, '.');
    const languagePath = getLanguagePath(language);

    const articleList = articles &&
        articles.filter(({ headline }) => headline)
            .map((article) => {
                const { id, headline, teamId } = article;
                const link = resourcePath.get(getArticleLinkType(article), {
                    game_pk: gamePk,
                    cid: id,
                    es: esToken,
                    languagePath
                });

                return {
                    id: teamId,
                    link,
                    headline,
                    dataAttr: {
                        'data-contentid': id,
                        'data-headline': headline
                    }
                };
            });

    return articleList;
};

export const getCoverageState = createSelector(
    [getCoverage, getLanguage, getIsLoading, getDeviceInteraction],
    (articleList, language, isLoading, deviceInteraction) => {
        return {
            articleList,
            language,
            isLoading,
            deviceInteraction
        };
    }
);
